document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('userNameInput');
  const button = document.getElementById('saveUserName');
  const banner = document.querySelector('.concept-video-banner');
  const heroContent = document.querySelector('.video-hero__content');
  const contentWrapper = document.querySelector('.video-hero__content-wrapper');
  const storageKey = 'concept_user_name';

  function setUserName(name) {
    document.querySelectorAll('.video_user_name').forEach(el => {
      el.textContent = name;
    });    
    const highlightUsername = document.querySelector('.highlight-username');
    if (highlightUsername) {
      highlightUsername.textContent = name;
    }
  }

  const storedName = localStorage.getItem(storageKey);

  if (storedName) {
    setUserName(storedName);
    banner && banner.remove();
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('concept-preload');
    return;
  }

  if (!banner) {
    document.documentElement.classList.remove('concept-preload');
    return;
  }

  if (contentWrapper) {
    setTimeout(() => {
      contentWrapper.classList.add('is-visible');
    }, 4000);
  }

  if (input && button) {
    button.addEventListener('click', function () {
      const name = input.value.trim();
      if (!name) return;

      localStorage.setItem(storageKey, name);
      setUserName(name);

      banner.classList.add('is-hiding');

      setTimeout(() => {
        banner.remove();
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('concept-preload');
      }, 1000);
    });
  }
});